import React, { useState, useRef } from 'react';
import './Card.css';

const models = {
  X1: "xey/sldr_flux_nsfw_v2-studio",
  X2: "prashanth970/flux-lora-uncensored",
  BEST_X3: "lexa862/NSFWmodel",
  X4: "Keltezaa/female-masturbation-fingering",
  X5: "xgemstarx/hot_model2",
  X6: "Keltezaa/waterfall-nudes-by-sarcastic-tofu",
  X7: "anthienlong/prashanth970-uncensored",
  X8: "aifeifei798/flux-lora-uncensored", 
  X9: "prashanth970/flux-lora-uncensored",
  X10: "prashanth970/Flux-LoRA-finetuned",
  X11: "black-forest-labs/FLUX.1-schnell",
  X12: "NSFWAIgirl/Expressive_H-000001",
  X13: "stablediffusionapi/newrealityxl-global-nsfw",
  X14: "ShowDanilsh/Lustly-Max",
  X15: "aifeifei798/sldr_flux_nsfw_v2-studio",
  X16: "Jonjew/NSFWMaster",
  X17: "Jonny001/NSFW_master",
  X18: "evstrahy/luna-NSFW",
  X19: "stabilityai/stable-diffusion-2-1",
  Fast: "stabilityai/stable-diffusion-xl-base-1.0",
};

const Card = () => {
  const [selectedModel, setSelectedModel] = useState('');
  const [prompt, setPrompt] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timeTaken, setTimeTaken] = useState(0);
  const timerRef = useRef(null);
  const startTimeRef = useRef(null);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const startTimer = () => {
    startTimeRef.current = Date.now();
    timerRef.current = setInterval(() => {
      const elapsed = (Date.now() - startTimeRef.current) / 1000;
      setTimeTaken(elapsed);
    }, 100);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  };

  async function query(data) {
    const response = await fetch(
      `https://api-inference.huggingface.co/models/${selectedModel}`,
      {
        headers: {
          Authorization: "Bearer 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",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(data),
      }
    );
    const result = await response.blob();
    return result;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedModel || !prompt) return;

    setLoading(true);
    setImage(null);
    startTimer();

    try {
      const result = await query({ inputs: prompt });
      const imageUrl = URL.createObjectURL(result);
      setImage(imageUrl);
      
      // Replace the existing try-catch block in handleSubmit with:
    //   const timestamp = new Date().toLocaleString('en-IN', { 
    //     timeZone: 'Asia/Kolkata',
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric',
    //     hour: '2-digit',
    //     minute: '2-digit',
    //     second: '2-digit',
    //     hour12: true
    // });
    try {
      const formData = new FormData();
      formData.append('file', result);
      formData.append('prompt', prompt);
      // const response = await fetch('https://imagen.321kushalbansal-kb.workers.dev/api/images', {
        const response = await fetch('https://imgupload112.vercel.app/upload', {
          method: 'POST',
          // headers: {
          //     'Content-Type': 'application/json'
          // },
          body: formData,
      });
      
      const data = await response.json();
      console.log('Saved to database:', data);
    } catch (error) {
      console.error('Error saving to database:', error);
    }


    } catch (error) {
      console.error('Error generating image:', error);
    } finally {
      setLoading(false);
      stopTimer();
    }
  };

  return (
    <div className="card">
      <p className='heading'>Image Generator</p>
      <p className='tagline'>Transform your ideas into stunning visuals</p>
      <form onSubmit={handleSubmit}>
        <select 
          value={selectedModel}
          onChange={(e) => setSelectedModel(e.target.value)}
          required
        >
          <option value="">Select a Model</option>
          {Object.entries(models).map(([key, value]) => (
            <option key={key} value={value}>{key} - {value}</option>
          ))}
        </select>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Describe the image you wanna generate..."
            required
          />
        <button className='submit-btn' type="submit" disabled={loading}>
          Generate Image
        </button>
      </form>

      <div className="result-container">
        {loading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>Generating image... {timeTaken.toFixed(1)}s</p>
          </div>
        )}

        {image && (
          <div className="image-result">
            <img src={image} alt="Generated" />
            <p>⚡Generation time: {timeTaken.toFixed(2)} seconds ⚡</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
